import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateGreaterThanValidator(compareDate: Date): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const convertNgbDateToDate = (ngbDate: any): Date => {
      return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
    }

    // Ensure the control has a value
    if (!control.value) {
      return null; // No validation error if no value
    }

    // Convert control value to a Date object
    const requestedDate = convertNgbDateToDate(control.value);

    if (compareDate.hasOwnProperty('year') && compareDate.hasOwnProperty('month') && compareDate.hasOwnProperty('day')) {
      compareDate = convertNgbDateToDate(compareDate);
    }

    requestedDate.setHours(0, 0, 0, 0);
    compareDate.setHours(0, 0, 0, 0);
    // Check if the requested date is greater than the compareDate
    return requestedDate > compareDate ? { dateNotGreater: true } : null;
  };
}
